<!--视频列表-->
<template>
  <div class="vl-all-box">


    <a-row :gutter="[16,16]">

      <!--      <a-col v-for="(item,index) in data" :span="6">-->
      <!--        <div  class="vl-single-box" >-->

      <!--          <div class="vl-single-title">设备名称：{{item.cDeviceAsName}}</div>-->

      <!--          <div style="width: 100%"><img src="../../img/video1.png" alt="" width="100%" height="180px"></div>-->

      <!--          <div class="vl-bottom-all-box">-->
      <!--            <div class="vl-bottom-button vl-bottom-left-button" @click="openzhibo(item)">开通</div>-->
      <!--&lt;!&ndash;            <div>|</div>&ndash;&gt;-->
      <!--            <div class="vl-bottom-button" @click="zhibo(item)">查看</div>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </a-col>-->


      <a-col v-for="(item,index) in data" :span="6">
        <div  class="vl-single-box" >

          <div class="vl-single-title">设备名称：{{item.cDeviceAsName}}-通道号：{{item.cChannelNo}}</div>

          <div style="width: 100%">
            <videoPlayer
              ref="videoPlayer"
              :options="item.cVideoUrl"
              class="vjs-custom-skin videoPlayer"
              :playsinline="true"

            />

          </div>




          <div class="vl-bottom-all-box">
            <div class="vl-bottom-button vl-bottom-left-button" @click="openzhibo(item)">开通</div>
            <!--            <div>|</div>-->
            <div class="vl-bottom-button" @click="zhibo(item)">查看</div>
          </div>
          <div class="vl-bottom-all-box">
            <div class="vl-bottom-button" @mousedown="xs(item)" @mouseup='ImageReturn'>向上</div>
            <div class="vl-bottom-button" @mousedown="xx(item)" @mouseup='ImageReturn'>向下</div>
            <div class="vl-bottom-button" @mousedown="xz(item)" @mouseup='ImageReturn'>向左</div>
            <div class="vl-bottom-button" @mousedown="xy(item)" @mouseup='ImageReturn'>向右</div>
            <div class="vl-bottom-button"  @mousedown="fd(item)" @mouseup='ImageReturn'>放大</div>
            <div class="vl-bottom-button"  @mousedown="sx(item)" @mouseup='ImageReturn'>缩小</div>
            <div class="vl-bottom-button" @mousedown="jjj(item)" @mouseup='ImageReturn'>近焦</div>
            <div class="vl-bottom-button" @mousedown="yjj(item)" @mouseup='ImageReturn'>远焦</div>
            <div class="vl-bottom-button" @click="mirror(item)">旋转</div>
          </div>
        </div>
      </a-col>

    </a-row>





  </div>
</template>

<script>
  // @ is an alias to /src
  import TitleCard from '@/components/TitleCard.vue'
  import 'video.js/dist/video-js.css'
  import 'vue-video-player/src/custom-theme.css'
  import { videoPlayer } from 'vue-video-player'
  import 'videojs-flash'

  const columns = [
    {
      title: '序列号',
      dataIndex: 'cDeviceSN',
      key: 'cDeviceSN',
    },
    {
      title: '设备名称',
      dataIndex: 'cDeviceName',
      key: 'cDeviceName',
    },

    {
      title: '操作',
      key: 'action',
      scopedSlots: { customRender: 'action' },
    },
  ];



  export default {
    name: 'clearPondList',
    components: {
      TitleCard,
      videoPlayer
    },
    data() {
      return {
        _item:[],
        direction:0,
        titleMsg1: "视频列表",
        titleMsg2:'视频列表',
        liveAddress:'',
        StartX:'168',
        StartY:'368',
        leftLooks: '',
        topLooks: '',
        radius: '60',
        touchStartX:0,
        touchStartY:0,
        direction:0,
        oldDirection:-1,
        titleMsg3:'视频列表',
        data:[],
        columns,
        record:{},
        zhibodata:{},
        paramas:{
          cSceneID:"",
          page:1,
          limit:10,
          cEntID:""
        },
        deleteModalVisible:false,

        record:{},


        // 以下是视频
        videoSrc: '',
        // 视频播放
        videoOptions: {
          playbackRates: [1.0], //播放速度
          autoplay: false, //如果true,浏览器准备好时开始回放。
          muted: false, // 默认情况下将会消除任何音频。
          loop: false, // 导致视频一结束就重新开始。
          preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
          language: 'zh-CN',
          aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
          techOrder: ['html5'],      // 兼容顺序
          sources: [{ // 流配置，数组形式，会根据兼容顺序自动切换
            type: 'application/x-mpegURL',
            src: ''
          }],
          poster: "", //你的封面地址
          // width: document.documentElement.clientWidth,
          notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
          controlBar: {
            timeDivider: true,
            ProgressControl:false,
          //  durationDisplay: false,
            remainingTimeDisplay: false,    ProcessBar: false,
            progressControl: false,
            autoDisable: true,
            fullscreenToggle: true  //全屏按钮
          }
        }
      }
    },
    mounted () {
      let that=this;

      that.paramas.cSceneID=that.$store.getters.SCene.ID;
      that.paramas.cEntID=that.$store.getters.User.enterprise.ID;
      that.handlePageList();
      that.$bus.$on('scenechange',(target)=> {
        that.paramas.cSceneID=target.id;
        that.handlePageList();
      });
    },
    methods:{

      mirror(item){
        let that = this;
        that._item=item;

        that.$http.post('/HkCamera/DevicePtzMirror?ID='+that._item.ID+'&command='+2);




      },

      DevicePtzStart(){
        let that = this;
        if(that.oldDirection==that.direction){
          return;
        }
        if(that.oldDirection!=-1){
          that.DevicePtzStop();
        }
        that.oldDirection=that.direction;




        try{
that.$http.post('/HkCamera/DevicePtzStart?ID='+that._item.ID+'&direction='+that.direction);
         if(1==2){
           request({
             url: '/api/HkCamera/DevicePtzStart?ID='+that._item.ID+'&direction='+that.direction,
             data: {
               ID:that._item.ID ,
               direction:that.direction
             },
             method: 'POST',

             success: function(res) {
               console.log(res,"成功")
             },
             fail: function(res) {
               console.log(res,"失败")
             }
           });
         }
        }
        catch(e){}

      },
      jjj(item){
        let that = this;
        that._item=item;
        that. direction=10;
        that.DevicePtzStart();
      },yjj(item){
        let that = this;
        that._item=item;
        that. direction=11;
        that.DevicePtzStart();
      },
      fd(item){
        let that = this;
        that._item=item;
        that. direction=8;
        that.DevicePtzStart();
      },sx(item){
        let that = this;
        that._item=item;
        that. direction=9;
        that.DevicePtzStart();
      },
      xy(item){
        let that = this;
        that._item=item;
        that. direction=3;
        console.log('x');
        that.DevicePtzStart();
      },
      xx(item){
        let that = this;
        that._item=item;
        that. direction=1;
        console.log('x');
        that.DevicePtzStart();
      },

      xz(item){
        let that = this;
        that._item=item;
        that. direction=2;
        console.log('x');
        that.DevicePtzStart();
      },

      xs(item){
        let that = this;
        that._item=item;
        that. direction=0;
        console.log('x');
        that.DevicePtzStart();
      },
      ImageReturn() {
        var self = this;
        self.DevicePtzStop();
        self.leftLooks=self.StartX+'px'
        self.topLooks=self.StartY+'px'
        console.log(1);

      },
      DevicePtzStop(){

        let that = this;
        that.oldDirection=-1

        that.$http.post('/HkCamera/DevicePtzStop?ID='+that._item.ID+'&direction='+that.direction);




      },
      async handlecancel(){
        // this.$refs['videoPlayer'].player.pause();
        this.videoOptions.sources=[{ // 流配置，数组形式，会根据兼容顺序自动切换
          type: 'application/x-mpegURL',
          src: ''
        }]
        this.deleteModalVisible=false;
      },
      async openzhibo(record){
        let that=this;

        let param={};
        param.accessToken=that.paramas.accessToken;

        param.deviceSerial=record.cDeviceSN;

        if (record.cChannelNo){
          param.channelNo=record.cChannelNo;
        }else{
          let res= await that.$http.post('HkCamera/GetTongDao?ID='+record.ID+'&deviceSerial='+param.deviceSerial,null)
          if(res.data.code=="200"){
            param.channelNo= res.data.message;
          }
          else{
            that.$message.error(res.message)
          }
        }
        let res2= await that.$http.post('HkCamera/OpenZhibo?ID='+record.ID+'&accessToken='+ param.accessToken+'&source='+param.deviceSerial+':'+param.channelNo,null)
        if(res2.data.message=="200"){
          that.$message.success(res2.data.message)

        }
        else{
          that.$message.error(res2.data.message)
        }


      },
      async zhibo(record){
        let that=this;

        if (record.cVideoUrl){

          that.videoOptions.sources=[{ // 流配置，数组形式，会根据兼容顺序自动切换
            type: 'application/x-mpegURL',
            src: record.cVideoUrl
          }]
          this.deleteModalVisible=true

        }else{
          let param={};
          param.accessToken=that.paramas.accessToken;

          param.deviceSerial=record.cDeviceSN;

          if (record.cChannelNo){
            param.channelNo=record.cChannelNo;
          }else{
            let res= await that.$http.post('HkCamera/GetTongDao?ID='+record.ID+'&deviceSerial='+param.deviceSerial,null)
            if(res.data.code=="200"){
              param.channelNo= res.data.message;
            }
            else{
              that.$message.error(res.message)
            }
          }
          let res2= await that.$http.post('HkCamera/GetZhibo?ID='+record.ID+'&deviceSerial='+param.deviceSerial+'&channelNo='+param.channelNo,null)
          if(res2.data.code=="200"){
            that.zhibodata= res2.data.message.rtmpHd;
            console.log(that.zhibodata)
            that.videoOptions.sources=[{ // 流配置，数组形式，会根据兼容顺序自动切换
              type: 'application/x-mpegURL',
              src: that.zhibodata
            }]
            this.deleteModalVisible=true
          }
          else{
            that.$message.error(res2.data.message)
          }

        }
      },

      async handlePageList(){

        let that=this;
        that.paramas.cSystemCode='节水灌溉'
        let res= await that.$http.post('HkCamera/List_New',that.paramas)

        if(res.data.code=="200"){

          that.data= res.data.obj.list;
          if (that.data&&that.data.length>0){
            that.data.forEach((ele,index)=>{
              ele.cVideoUrl= {
                playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
                autoplay: true, //如果true,浏览器准备好时开始回放。
                muted: false, // 默认情况下将会消除任何音频。
                loop: false, // 导致视频一结束就重新开始。
                preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                language: 'zh-CN',
                aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                techOrder: ['flash', 'html5'],      // 兼容顺序
                sources: [{ // 流配置，数组形式，会根据兼容顺序自动切换
                  type: 'rtmp/hls',
                  src: ele.cVideoFlashUrl
                }],
                poster: "", //你的封面地址
                // width: document.documentElement.clientWidth,
                notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
                controlBar: {
                  timeDivider: true,
                  ProgressControl:false,
                  durationDisplay: true,
                  remainingTimeDisplay: false,    ProcessBar: false,
                  progressControl: false,
                  autoDisable: true,
                  fullscreenToggle: true  //全屏按钮
                }
              }
            })
          }
        }
        else{
          that.$message.error(res.message)

        }
      },
      showDeleteModal:function (obj) {
        this.record=obj;
        this.deleteModalVisible=true
      },

      //视频弹窗
      async handleDelete(){
        this.deleteModalVisible=false;
      },
    },
    computed:{
      player(){
        return this.$refs.videoPlayer.player
      }
    }
  }
</script>

<style scoped>
  @import "video.css";
  .video-box {
    width: 1000px;
    padding: 20px;
  }
</style>
